// extracted by mini-css-extract-plugin
export default {"legendItem":"legend-item_legendItem__tKHIa","blob":"legend-item_blob__w6VIt","required":"legend-item_required__0U499"};